import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00128934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex font-quatro flex-wrap justify-content-center" }
const _hoisted_2 = { class: "me-2" }
const _hoisted_3 = {
  key: 0,
  class: "break"
}

interface Props {
  title: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FancyTitle',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Separate the title into its words, add a line break every three words "),
    _createElementVNode("h1", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.title.split(' '), (word, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(word), 1 /* TEXT */),
          ((Number(index) + 1) % 3 === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})